import { Routes, Route } from 'react-router';
import { AltLenderDetail, Lenders, LenderDetail } from 'pages';

const LendersLayout = () => (
  <Routes>
    <Route index element={<Lenders />} />
    <Route path=":id" element={<LenderDetail />} />
    <Route path="alternative/:id" element={<AltLenderDetail />} />
  </Routes>
);

export default LendersLayout;
